import { Header } from "../Compnents/Layout";
import { Container } from "react-bootstrap";
import { Home, NotFound } from "../Pages";
import { Routes, Route } from "react-router-dom";
import { CampaignDetails, CampaignList, CampaignUpsert } from "../Pages/Campaign";
import { QuizDetails,QuizList,QuizUpsert } from "../Pages/Quiz";
import { Login, Register,ForgotPassword,ChangePassword, Users,RegisterConfirmation } from "../Pages/Identity";
import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { userModel } from "../Interfaces";
import { setLoggedInUser } from "../Storage/Redux/userAuthSlice";
import { useDispatch } from "react-redux";
import { QuestionCreate, QuestionDetails } from "../Pages/Question";
import ProtectedRoute from "../Components/ProtectedRoute";



function App() {
  const dispatch = useDispatch()

  useEffect(() => {
    const localToken  = localStorage.getItem("token");
    if(localToken){
    const { fullName, nameid, email, role }: userModel = jwtDecode(localToken);
    dispatch(setLoggedInUser({fullName,nameid,email,role}));
    }
  },[dispatch]);
  
  return (
    <div>
      <Header />

      <Container className="mt-4">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/Campaign/Details/:campaignId"
            element={<CampaignDetails />}
          />
          <Route path="/Campaign/List" element={<CampaignList />} />
          <Route path="/Campaign/Create" element={<CampaignUpsert />} />
          <Route
            path="/Campaign/Edit/:campaignId"
            element={<CampaignUpsert />}
          />
          <Route path="/Quiz/Details/:quizId" element={<QuizDetails />} />
          <Route path="/Quiz/List" element={<QuizList />} />
          <Route path="/Quiz/create" element={<QuizUpsert />} />
          <Route path="/Quiz/Edit/:quizId" element={<QuizUpsert />} />
          <Route path="/Question/List" element={<QuestionDetails />} />
          <Route path="/Question/Create" element={<QuestionCreate />} />
          <Route element={<ProtectedRoute isAuthRoute={true} />}>
            <Route path="/Register" element={<Register />} />
            <Route path="/RegisterConfirm" element={<RegisterConfirmation />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/ChangePassword" element={<ChangePassword />} />
          </Route>
          <Route path="/Users" element={<Users />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Container>
    </div>
  );
}

export default App;
